import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import {Descriptions, Drawer} from 'antd';

const CertificateInfo = (props) => {
  const intl = useIntl();

  const {selectedCertificate, viewing, setViewing} = props;

  const onClose = () => {
    setViewing(false);
  };

  return (
    <>
      <Drawer
        title={intl.messages['common.detail']}
        width={800}
        onClose={onClose}
        visible={viewing}
        destroyOnClose={true}
        bodyStyle={{paddingBottom: 80}}>
        <Descriptions
          bordered
          size='middle'
          style={{paddingTop: 10}}
          column={2}>
          <Descriptions.Item
            label={intl.messages['practitioner.certificate.certNumber']}>
            {selectedCertificate?.certNumber}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['practitioner.certificate.name']}>
            {selectedCertificate?.name}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['practitioner.certificate.startTime']}>
            {selectedCertificate?.period?.start}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['practitioner.certificate.endTime']}>
            {selectedCertificate?.period?.end}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['practitioner.certificate.issuer']}
            span={2}>
            {selectedCertificate?.issuer?.name}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['practitioner.certificate.scope']}
            span={2}>
            {selectedCertificate?.scope}
          </Descriptions.Item>
        </Descriptions>
      </Drawer>
    </>
  );
};

export default CertificateInfo;

CertificateInfo.propTypes = {
  selectedCertificate: PropTypes.object,
  viewing: PropTypes.bool.isRequired,
  setViewing: PropTypes.func.isRequired,
};
